// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3Pfop","empty":"ModalGraph_empty__2E1p7"};